import { render } from "./Trick.vue?vue&type=template&id=44fc0133&scoped=true"
import script from "./Trick.vue?vue&type=script&lang=js"
export * from "./Trick.vue?vue&type=script&lang=js"

import "./Trick.vue?vue&type=style&index=0&id=44fc0133&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44fc0133"]])

export default __exports__